module.exports = __webpack_public_path__ + "img/sixdotsmobile.210a3719.svg";